import React from "react";
import { Box, Typography } from "@mui/material";

import DashboardCard from "../Common/DashboardCard";
import SectionHeader from "../Common/SectionHeader";
import StatusChip from "../Common/StatusChip";

/**
 * Replaces the old SavedMachines.js placeholder.
 *
 * There is no "saved/favorited machine" relation on the User model —
 * so this can't truly be a "Saved Machines" list yet. It IS wired to
 * real Machine data (name, status1 -> Available/Under Maintenance/Out
 * of Order) via GET /admin_machine_list/, so it ships as a working
 * "Browse Machines" card today.
 *
 * Once the backend adds a favorites/saved relation, swap the fetched
 * list for the user's saved subset and rename back to "Saved Machines"
 * — no changes needed here beyond the title and the data passed in.
 */
export default function AvailableMachines({ machines = [], onViewAll }) {
    console.log(machines);
    return (
        <DashboardCard>
            <SectionHeader
                title="Browse Machines"
                actionText="View All"
                onAction={onViewAll}
            />

            {machines.length === 0 ? (
                <Typography sx={{ color: "#94A3B8", fontSize: 14 }}>
                    No machines to show.
                </Typography>
            ) : (
               <Box
    sx={{
        display: "grid",
        gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(4, 1fr)",
        },
        gap: 2,
    }}
>
                    {machines.map((machine) => (
                        <Box
                                   sx={{
                                       border: "1px solid #E8EDF5",
                                       backgroundColor:"#F1F4F9",
                                       borderRadius: "14px",
                                       p: 1,
                                       
                                       "&:last-child": {
                                           mb: 0,
                                       },
                                   }}
                               >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    mb: 1,
                                }}
                            >
                                <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
                                    {machine.name}
                                </Typography>
                                <StatusChip status={machine.status} />
                            </Box>

                            {machine.category && (
                                <Typography sx={{ color: "#64748B", fontSize: 13 }}>
                                    {machine.category}
                                </Typography>
                            )}
                        </Box>
                    ))}
                </Box>
            )}
        </DashboardCard>
    );
}
